import { render } from "./MembershipUserTypeTable.vue?vue&type=template&id=5a58a8b8"
import script from "./MembershipUserTypeTable.vue?vue&type=script&lang=js"
export * from "./MembershipUserTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__